var _defs, _circle, _circle2, _circle3, _path, _g, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    role: "img",
    "aria-label": "FAA Safety Management System",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smsRing",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A829D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#065B70"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 76,
    fill: "url(#smsRing)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 68,
    fill: "none",
    stroke: "#35D7E4",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 60,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 32 L108 42 L108 68 C108 88 94 102 80 108 C66 102 52 88 52 68 L52 42 Z",
    fill: "#0A829D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 62,
    rx: 13,
    ry: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 61 L60 55 L62 62 L60 68 L74 64 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 61 L100 55 L98 62 L100 68 L86 64 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 64 L80 74 L83 64 Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78 L76 86 L94 66",
    fill: "none",
    stroke: "#35D7E4",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 128,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 2,
    fill: "#065B70"
  }, "SMS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsBadge);
export default __webpack_public_path__ + "static/media/SMS_Badge.84e9bc71b2134c7de0ebc5b61d3ed1b2.svg";
export { ForwardRef as ReactComponent };